import { createApp } from 'vue'
import App from './App.vue'
import './style.css'
import { state, hydrate, restoreSources, flushPersist } from './lib/store'
import { restoreSession } from './lib/auth'
import { startSelectionSync } from './lib/sync'
import { installTelemetry } from './lib/telemetry'

function mount(): void {
  createApp(App).mount('#app')
}

async function start(insideOffice: boolean): Promise<void> {
  state.insideOffice = insideOffice
  if (insideOffice) {
    try {
      await hydrate() // load persisted metadata from the workbook (Custom XML Part)
      void restoreSources() // then reload embedded document sources so pages show without re-import
    } catch {
      /* workbook storage unavailable — start empty */
    }
    // Flush any debounced state before the pane is torn down so nothing is lost.
    const flush = () => flushPersist()
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'hidden') flush()
    })
    window.addEventListener('pagehide', flush)
  }
  state.ready = true
  installTelemetry()
  // Restore any existing session in the background (sets auth.ready when done).
  void restoreSession()
  if (insideOffice) void startSelectionSync()
  mount()
}

// Office.js is always present (loaded from CDN in index.html). Outside an Office
// host it still resolves onReady with host === null, which lets the same build run
// in a plain browser for development/preview.
if (typeof Office !== 'undefined' && typeof Office.onReady === 'function') {
  Office.onReady((info) => {
    void start(info.host === Office.HostType.Excel)
  })
} else {
  void start(false)
}
